import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "portal-page info-preparing" }
const _hoisted_2 = { class: "portal-page__inner" }
const _hoisted_3 = { class: "info-preparing__card portal-panel" }
const _hoisted_4 = ["src"]

import { illust } from '@/constants/illust'

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoPreparingPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "info-preparing__art",
          src: _unref(illust).infoPreparing,
          alt: "클립보드 옆에 앉아 있는 민트색 캐릭터"
        }, null, 8, _hoisted_4),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-preparing__kicker" }, "정보마당", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "info-preparing__title" }, "준비중이에요", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-preparing__desc" }, "내용을 정리하고 있습니다. 조금만 기다려 주세요.", -1)),
        _createVNode(_component_router_link, {
          to: "/",
          class: "portal-btn portal-btn--primary"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("홈으로", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})